import { render, staticRenderFns } from "./withDralSucc.vue?vue&type=template&id=527e4025&scoped=true&"
import script from "./withDralSucc.vue?vue&type=script&lang=js&"
export * from "./withDralSucc.vue?vue&type=script&lang=js&"
import style0 from "./withDralSucc.vue?vue&type=style&index=0&id=527e4025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527e4025",
  null
  
)

export default component.exports